var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dynamic-tag', {
    class: _vm.classes,
    attrs: {
      "tag": _vm.url ? 'a' : 'button',
      "on": {
        click: _vm.onClick,
        blur: _vm.onBlur,
        focus: _vm.onFocus
      },
      "type": _vm.submit ? 'submit' : 'button',
      "aria-label": _vm.accessibilityLabel,
      "data-polaris-unstyled": _vm.url ? 'true' : '',
      "href": _vm.url,
      "disabled": _vm.isDisabled,
      "target": _vm.external ? '_blank' : '',
      "role": _vm.loading ? 'alert' : null,
      "aria-busy": _vm.loading ? true : null
    }
  }, [(_vm.loading) ? _c('span', {
    staticClass: "Polaris-Button__Spinner"
  }, [_c('polaris-spinner', {
    attrs: {
      "size": "small",
      "color": _vm.spinnerColor,
      "accessibility-label": "Loading"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.icon) ? _c('span', {
    staticClass: "Polaris-Button__Icon"
  }, [_c('polaris-icon', {
    attrs: {
      "source": _vm.realIcon
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$slots.default) ? _c('span', {
    staticClass: "Polaris-Button__Content"
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (_vm.disclosure) ? _c('span', {
    staticClass: "Polaris-Button__Icon"
  }, [_c('polaris-icon', {
    attrs: {
      "source": _vm.disclosureIcon
    }
  })], 1) : _vm._e()])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0646185e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0646185e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisButton.vue
// module id = 120
// module chunks = 0